// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PMsqU","col":"styles_col__3oLbG","actions":"styles_actions__BfiEe","conflict":"styles_conflict__2G3RQ"};